import React from "react";
import { useI18n } from "../i18n";
import { useHelpOpener } from "../help/useHelp";

/** Which help topic explains each screen. */
const TOPIC = {
  cash: "cash",
  deliveries: "supply",
  packs: "packs",
  reminders: "reminders",
  savings: "savings",
  stock: "stock",
  suppliers: "supply",
  expenses: "expenses",
  offers: "offers",
  preorders: "preorders",
  journal: "journal",
  materials: "mixing",
  recipes: "mixing",
  credit: "credit",
  purchases: "sales",
  batches: "mixing",
};

/**
 * What a screen shows when it has nothing to list: the plain fact ("No packs
 * yet"), one line on what the screen is for, and a way into its help topic.
 * An empty list is where a new owner is most lost, so it explains rather than
 * just stating that nothing is there.
 */
const EmptyState = ({ screen, message, className = "py-8" }) => {
  const { t } = useI18n();
  const openHelp = useHelpOpener();
  const topic = TOPIC[screen];

  return (
    <div className={`text-center px-4 ${className}`}>
      <p className="text-gray-700 font-medium">{message}</p>
      <p className="text-gray-500 text-sm mt-1 max-w-md mx-auto">{t(`support.empty.${screen}`)}</p>
      {topic && (
        <button
          type="button"
          onClick={() => openHelp(topic)}
          className="mt-3 text-sm font-medium text-primary-700 hover:underline"
        >
          {t("support.learnMore")}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
